﻿import { projectSettings } from "../../config";


import FileUploadLandingPage from "./LandingPage.svelte";
import FileUploadDocumentUpload from "./DocumentUpload.svelte";
import FileUploadThankYou from "./ThankYou.svelte";

const title = projectSettings.classActionName;


const documentUploadPageList = [
    {
        pageIndex: 0,
        component: FileUploadLandingPage,
        title: "Document Upload Form",
        showInTracker: true,
        routeId: "/FileUpload",
        nextPage: "/FileUpload/DocumentUpload",
        properties: {
            pageTitle: `${projectSettings.classActionName}`,
        },
    },
    {
        pageIndex: 1,
        component: FileUploadDocumentUpload,
        title: "Document Upload",
        showInTracker: true,
        routeId: "/FileUpload/DocumentUpload",
        nextPage: "/FileUpload/ThankYou",
        previousPage: "/FileUpload",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Document Upload`,
            persistUrl: `/api/file-upload-submit`,
        },
    },
    {
        pageIndex: 2,
        component: FileUploadThankYou,
        title: "Document Upload Submitted",
        showInTracker: false,
        routeId: "/FileUpload/ThankYou",
        properties: {
            pageTitle: `${projectSettings.classActionName} - Thank you`,
        },
    },
];

export default documentUploadPageList
